(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initInstance(root) {
    if (root.__waveMarqueeInited) return;
    root.__waveMarqueeInited = true;

    var guide = root.querySelector('.wave-marquee__guide');
    var textPath = root.querySelector('.wave-marquee__textpath');
    if (!guide || !textPath) return;

    var pathLen = guide.getTotalLength();

    var baseText = textPath.textContent;
    var unitLength = textPath.getComputedTextLength() || pathLen;
    var repeats = Math.max(1, Math.ceil(pathLen / unitLength) + 2);
    textPath.textContent = baseText.repeat(repeats);

    var speed = parseFloat(root.dataset.speed) || 40; // user-units per second
    var offset = 0;
    var lastTime = null;
    var running = !prefersReduced;
    var rafId = null;

    function tick(now) {
      if (lastTime == null) lastTime = now;
      var dt = (now - lastTime) / 1000;
      lastTime = now;

      if (running) {
        offset -= speed * dt;
        // if (offset <= -pathLen) offset += pathLen;

        if (offset <= -unitLength) offset += unitLength;
        textPath.setAttribute('startOffset', offset);
      }
      rafId = requestAnimationFrame(tick);
    }

    if (!prefersReduced) {
      rafId = requestAnimationFrame(tick);
    }

    // Pause while off-screen
    var io = new IntersectionObserver(function (entries) {
      running = entries[0].isIntersecting && !prefersReduced;
    }, { threshold: 0 });
    io.observe(root);

    // Cleanup on section removal (theme editor re-renders the section DOM)
    root.__waveMarqueeCleanup = function () {
      if (rafId) cancelAnimationFrame(rafId);
      io.disconnect();
      root.__waveMarqueeInited = false;
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wave-marquee]').forEach(initInstance);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // Shopify theme editor support: re-init on section load, clean up on unload
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-wave-marquee]');
    if (root && root.__waveMarqueeCleanup) root.__waveMarqueeCleanup();
  });
})();
